import { NgModule } from '@angular/core';
import { TableModule } from 'primeng/table';
import { SharedPipesModule } from '../../../../shared/pipes/shared-pipes.module';
import { SharedModule } from '../../../../shared/shared.module';
import { VehiclePermitService } from '../../../../vehicle/services/vehicle-permit.service';
import { PermitSearchComponent } from './permit-search.component';

@NgModule({
    declarations: [
        PermitSearchComponent
    ],
    providers: [
        VehiclePermitService
    ],
    exports: [
        PermitSearchComponent
    ],
    imports: [
        SharedModule,
        SharedPipesModule,
        TableModule
    ]
})
export class PermitSearchModule {
}
